import { render, staticRenderFns } from "./ContactEditExtraInfo.vue?vue&type=template&id=17051630"
import script from "./ContactEditExtraInfo.vue?vue&type=script&lang=ts"
export * from "./ContactEditExtraInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17051630')) {
      api.createRecord('17051630', component.options)
    } else {
      api.reload('17051630', component.options)
    }
    module.hot.accept("./ContactEditExtraInfo.vue?vue&type=template&id=17051630", function () {
      api.rerender('17051630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactEditExtraInfo.vue"
export default component.exports